import { Notification } from '@connect-x-app/shared-domain-models';

export const sortNotificationsByCreatedAt = (n1: Notification, n2: Notification) => {
  const f1Std = new Date(n1.createdAt).getTime();
  const f2Std = new Date(n2.createdAt).getTime();

  return f2Std - f1Std;
};
